import React, { createContext, useContext, useState } from 'react';
import { deriveAcademyTheme } from '../../utils/academyBranding';

// The .ap-shell root element itself, for overlays (Sheet) to portal into.
// A Sheet rendered where it's declared inherits whatever stacking context
// its ancestors create — e.g. one opened from the sticky z-40 mobile header
// (InviteDropdown, ProgramSwitcher) was trapped under the z-40 tab bar, which
// hid its footer buttons on phones. Portalling to the shell root keeps every
// Sheet above the header/tab bar while still inheriting the .ap-shell tokens
// and per-academy brand overrides.
const ShellRootContext = createContext(null);
export const useAcademyShellRoot = () => useContext(ShellRootContext);

// Renders the Academy Portal's root wrapper: applies the .ap-shell token
// set (src/styles/academyPortal.css) and, when the academy has a brand
// colour set, overrides the accent/navy vars with ones derived from it —
// as inline style on this same element, so it wins over the stylesheet
// defaults via ordinary cascade with no extra JS wiring per screen.
export default function AcademyThemeVars({ academy, className = '', children }) {
  const overrides = deriveAcademyTheme(academy?.branding?.primaryColor) || {};
  const [root, setRoot] = useState(null);
  return (
    <div ref={setRoot} className={`ap-shell ${className}`} style={overrides}>
      <ShellRootContext.Provider value={root}>
        {children}
      </ShellRootContext.Provider>
    </div>
  );
}
